// extracted by mini-css-extract-plugin
export default {"tabs__indicator":"Tabs_tabs__indicator__sOcCm","tabs__root":"Tabs_tabs__root__vGwVP","tabs__container":"Tabs_tabs__container__vyIBT"};